import { TransProp } from '@icc/shared/helpers';
import { RollerGuideDrilling } from './guide-drilling';

/** Prowadzenia */
export class RollerGuidesDrillings {
    id: number;
    /** Id żaluzji */
    shutterId: number;
    /** Lewe prowdzenie.
     *
     * Gdy jest przygotowanie pod prowadzenie to jest równe `null`
     */
    @TransProp()
    left: RollerGuideDrilling | null;
    /**
     * Prawe prowadzenie
     *
     * Gdy jest przygotowanie pod prowadzenie to jest równe `null`
     */
    @TransProp()
    right: RollerGuideDrilling | null;

    /** Prowadzenia podziałowe moskitier */
    mosquitoScreens: {
        drilling: RollerGuideDrilling;
        leftMosquitoScreenId: number | null;
        rightMosquitoScreenId: number | null;
    }[];
}
